import React, { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import PrivateRoutes from '../utils/PrivateRoutes';
import {
  SettingsLayout,
  VendorMasterLayout,
  AddVendorLayout,
  AllUsersLayout,
  AddUserLayout,
  TransfersLayout,
  StatusLayout,
  RejectedLayout,
  AuditLogLayout,
  ApprovalsLayout,
  BankTransactionsLayout,
  BcInvoicesLayout,
  MatchReviewLayout,
} from './themeLayoutConfigs';
import NotFoundPage from '../components/shared-components/NotFoundPage';
import './themeLayouts.css';
import Cookies from 'js-cookie';
import api from '../interceptors/axios';

const ThemeLayoutsComponent = () => {
  const timeout = 30 * 60 * 1000;
  // const timeout = 10 * 60 * 1000;
  const promptBeforeIdle = 30 * 1000;

  const [state, setState] = useState('Active');
  const [remaining, setRemaining] = useState(timeout / 1000);
  const [showPrompt, setShowPrompt] = useState(false); 

  const navigate = useNavigate();

  const onIdle = () => {
    setState('Idle');
    setShowPrompt(true);
  };

  const onActive = () => {
    setState('Active');
    setShowPrompt(false);
  };

  const onPrompt = () => {
    setState('Idle');
    setShowPrompt(true); 
  };

  const { getRemainingTime, activate } = useIdleTimer({
    onIdle,
    onActive,
    onPrompt,
    timeout,
    promptBeforeIdle,
    throttle: 500,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const remainingTime = Math.ceil(getRemainingTime() / 1000);
      setRemaining(remainingTime);
      if (remainingTime <= 0) {
        handleLogout(); // Call logout function when remaining time is zero
      }
    }, 500);

    return () => {
      clearInterval(interval);
    };
  }, [getRemainingTime]);

  const handleLogout = async () => {
    try {
        await api.post("/user/logout");
        Cookies.remove('userState');
        Cookies.remove("fullName");
        Cookies.remove("userRole");
        Cookies.remove("accessToken");
        Cookies.remove("refreshToken");
        Cookies.remove("lastLogin");
        Cookies.remove("isEntExcluded");
        Cookies.remove("code");
        navigate("/");
    } catch (error) {
      console.error("Error updating status: ", error);
    } 
  };
  const handleStillHere = () => {
    activate();
    setShowPrompt(false); 
  };

  const timeTillPrompt = Math.max(remaining - promptBeforeIdle / 1000, 0);
  const seconds = timeTillPrompt > 1 ? 'seconds' : 'second';

  Cookies.set('userState', state, { expires: 7 });

  return (
    <div>
      <Routes>
        <Route element={<PrivateRoutes />}>
          <Route path="/settings" element={<SettingsLayout />} />
          <Route path="/vendor-master" element={<VendorMasterLayout />} />
          <Route path="/vendor-master/add-vendor" element={<AddVendorLayout />} />
          <Route path="/retrieve-transaction" element={<Navigate to="/transaction-retrieval/bank-transactions" replace />} />
          <Route path="/transaction-retrieval/bank-transactions" element={<BankTransactionsLayout />} />
          <Route path="/transaction-retrieval/bc-invoices" element={<BcInvoicesLayout />} />
          <Route path="/transaction-retrieval/match-review" element={<MatchReviewLayout />} />
          <Route path="/settings/all-users" element={<AllUsersLayout />} />
          <Route path="/settings/add-user" element={<AddUserLayout />} />
          <Route path="/fund-transfer/transfers" element={<TransfersLayout />} />
          <Route path="/fund-transfer/approvals" element={<ApprovalsLayout />} />
          <Route path="/fund-transfer/status" element={<StatusLayout />} />
          <Route path="/fund-transfer/rejected" element={<RejectedLayout />} />
          <Route path="/audit-log" element={<AuditLogLayout />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>

      {/* Prompt modal */}
      {showPrompt && (
        <div className="modal">
          <h3>Are you still here?</h3>
          <p>Logging out in {remaining} seconds</p>
          <button onClick={handleStillHere}>I'm still here</button>
        </div>
      )}
    </div>
  );
};

export default ThemeLayoutsComponent;
